module.exports = __webpack_public_path__ + "img/sweat.dbd5db59.svg";